import { render } from "./ListCharacters.vue?vue&type=template&id=e63cf646"
import script from "./ListCharacters.vue?vue&type=script&lang=js"
export * from "./ListCharacters.vue?vue&type=script&lang=js"

import "./ListCharacters.vue?vue&type=style&index=0&id=e63cf646&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__